/** Synthetic map id for the permitting PDF embed — never sent to map/object file APIs. */
export const PERMITTING_LOCAL_MAP_ID = '__permitting_local_map__';

export function isPermittingLocalMap(mapId: string | undefined): boolean {
  return mapId === PERMITTING_LOCAL_MAP_ID;
}
